
import React, { useState, useEffect, Fragment, useRef } from "react";
import { useHistory } from "react-router-dom";

import MaterialTable from "material-table";
import {

  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import validator from 'validator';
import { useTheme } from '@mui/material/styles';
import CloseIcon from "@material-ui/icons/Close";
import { exportMaterialTableToExcel, exportMaterialTableToPDF, getDateString } from "../../utilities/utility";
import { checkUserAccess, getCheckSession } from "../../apis/auth";
import { Backdrop, Box, Button, Checkbox, CircularProgress, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormHelperText, FormLabel, IconButton, InputLabel, Menu, MenuItem, Paper, Radio, RadioGroup, Select, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tabs, TextField, Typography, useMediaQuery } from "@material-ui/core";
import { addUser, getAllDisplayNames, getAllPermissionConfig, getAllUser, updatePermissionConfig, addPermissionConfig, updateUser, getAllProject } from "../../query/users.query";
import { NotificationManager } from "react-notifications";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddIcon from '@mui/icons-material/Add';
import { updateProjectMaintenanceData } from "../../query/device.query";

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(2),
      top: theme.spacing(2),
      color: theme.palette.grey[500],
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    tab: {
      '& .MuiTabPanel-root': {
        padding: '0px',
      },
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      opacity: 0.5,
    },
  })
);

const Project = () => {
  const classes = useStyles();
  const history = useHistory();
  const [projectList, setProjectList] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  //field name
  const [name, setName] = useState('');
  const [id, setId] = useState('');

  //error field name
  const [nameError, setNameError] = useState('');
  const [idError, setIdError] = useState('');
  const [openDialog, setOpenDialog] = useState(null);

  useEffect(async () => {
    console.log("========== LiveMeterFeed : OnInit() ==========");
    var sessionStatus = await getCheckSession();
    if (sessionStatus === false) {
      history.push("/");
      return;
    }
    getAllData();
  }, []);

  const getAllData = async () => {
    await getAllProject().then((data) => {
      setProjectList(data?.projects.map(item => ({ ...item })) ?? []);
      setProjectData(data?.projects.map(item => ({ ...item })) ?? []);
    })
  }

  const hideAddUserDialog = () => {
    setNameError('')
    setOpenDialog(null)
    setSelectedRow(null)
    setName('');
    setId('');
    setIdError('');
  }

  const update = () => {
    let error = false;

    if (name.trim() === "" || name.trim().length <= 0) {
      setNameError("Enter Project name");
      error = true;
    } else {
      setNameError("");
    }

    const parsedId = parseInt(id, 10); // Ensure id is a number

    const keyExists = projectData.some((e) => e.project_id === parsedId);
    if (keyExists && parsedId !== selectedRow?.project_id) {
      setIdError("Project ID already exists");
      error = true;
    } else if (isNaN(parsedId) || parsedId <= 0) {
      setIdError("Enter a valid Project ID");
      error = true;
    } else {
      setIdError("");
    }
    if (error) {
      return;
    }
    const updatedData = projectData.map(item => item.project_id === selectedRow.project_id ? { ...item, project_name: name, project_id: parseInt(id, 10) } : item);
    updateProjectMaintenanceData(updatedData).then((e) => {
      getAllData();
      hideAddUserDialog();
      NotificationManager.success("Project updated successfully", "", 3000);
    }).catch((e) => {
      alert(e)
      NotificationManager.error("Unable to update Project", "", 3000);
    });
  }

  const add = () => {
    var error = false;
    if (name.trim() === "" || name.trim().length <= 0) {
      setNameError("Enter Project name");
      error = true;
    } else {
      setNameError("");
    }
    const parsedId = parseInt(id, 10);
    const keyExists = projectData.some((e) => e.project_id === parsedId);
    if (keyExists) {
      setIdError("Project ID already exists");
      error = true;
    } else if (isNaN(parsedId) || parsedId <= 0) {
      setIdError("Enter a valid Project ID");
      error = true;
    } else {
      setIdError("");
    }


    if (error) {
      return;
    }

    updateProjectMaintenanceData([...projectData, { project_id: parseInt(id, 10), project_name: name }]).then((e) => {
      getAllData();
      setProjectList((prev) => {
        return [...prev, { project_id: parseInt(id, 10), project_name: name }];
      });
      NotificationManager.success("Project created successfully", "", 3000);
      hideAddUserDialog();
    }).catch((e) => {
      alert(e)
      NotificationManager.error("Unable to create project", "", 3000);
    });

  }

  const getOpReportColumnList = () => {
    return [
      {
        title: 'project_id',
        field: 'project_id',
        searchable: true,
        render: ({ project_id: project_id = "" }) => {
          return project_id;
        },
        exportTransformer: ({ project_id: project_id = "" }) => {
          return project_id
        }
      },
      {
        title: 'project_name',
        field: 'project_name',
        render: ({ project_name: project_name = "" }) => {
          return project_name;
        },
        exportTransformer: ({ project_name: project_name = "" }) => {
          return project_name
        }
      },
    ];

  };

  return (
    <div className="reports">

      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        boxSizing: "border-box",
      }}>
        <h2  >Project List</h2>
        <Button style={{
          backgroundColor: "#0071CE",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
          onClick={() => {
            setOpenDialog(true);
            const maxProjectId = Math.max(...projectData.map(item => item.project_id), 0);
            setId(maxProjectId + 1)
          }}
        >
          Add Project
        </Button>
      </div>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <div className="dashboard-table">
          <MaterialTable
            style={{
              margin: "20px 0",
              width: "100%",
            }}
            className={classes.table}
            title=""
            columns={getOpReportColumnList()}
            data={projectList}
            actions={[
              {
                icon: 'edit',
                iconProps: { color: "action" },
                tooltip: 'Edit Dim Schedule',
                onClick: (event, rowData) => {
                  setSelectedRow(rowData);
                  setName(rowData.project_name);
                  setId(rowData.project_id);
                }
              },
              // {
              //     icon: 'delete',
              //     tooltip: 'Delete Dim Schedule',
              //     onClick: (event, rowData) => {

              //     }
              // },
            ]}
            options={{
              exportButton: true,
              exportAllData: true,
              exportCsv: (columns, csvData) => { exportMaterialTableToExcel(columns, csvData, `Project report-${getDateString()}`); },
              exportPdf: (columns, csvData) => { exportMaterialTableToPDF(columns, csvData, `Project Report-${getDateString()}`, 8, 18); },
              search: true,
              selection: false,
              sorting: true,
              pageSize: 10,
              headerStyle: {
                backgroundColor: "#0071CE",
                color: "#FFF",
                fontSize: "0.9em",
                textAlign: "center",
              },
              actionsColumnIndex: -1,
              emptyRowsWhenPaging: false,
            }}
            localization={{
              toolbar: {
                searchPlaceholder: "Search",
                exportCSVName: "Export as Excel",
                exportPDFName: "Export as PDF",
              },
            }}
          />     </div>
      </Box>

      <Dialog className="history-dialog" open={selectedRow != null || openDialog} onClose={hideAddUserDialog} aria-labelledby="form-dialog-title" sx={{
        '& .MuiDialogContainer-root': {
          maxWidth: '70%',
          height: '90vh',
        },
      }}
      >
        <DialogTitle id="editTime-dialog-title" onClose={hideAddUserDialog}>
          {openDialog ? 'New' : 'Update'} Project
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={hideAddUserDialog}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
            <TextField
              margin="dense"
              id="id"
              label="Project Id"
              error={idError.length > 0 ? true : false}
              helperText={idError}
              type="number"
              onWheel={(e) => {
                e.target.blur()
              }}
              value={id}
              onChange={(e) => { setId(e.target.value); setIdError('') }}
            />
          </FormControl>
          <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Project Name"
              error={nameError.length > 0 ? true : false}
              helperText={nameError}
              type="text"
              value={name}
              onChange={(e) => { setName(e.target.value); setNameError('') }}
            />
          </FormControl>

        </DialogContent>
        <DialogActions>
          <Button onClick={hideAddUserDialog}>
            Cancel
          </Button>
          <Button onClick={() => { openDialog ? add() : update() }} type="submit">
            {openDialog ? "Create" : "Update"}
          </Button>
        </DialogActions>
      </Dialog>
    </div >
  );
};

export default Project;